import { useEffect, useRef, useState } from 'react'

const useIntersect = (ref, threshold = Array.from(Array(100).keys(), i => i / 100)) => {
  const root = null
  const rootMargin = '0px'

  const [intersectionEntry, setIntersectionEntry] = useState({})

  const observer = useRef(null)

  useEffect(() => {
    observer.current && observer.current.disconnect()

    observer.current = new window.IntersectionObserver(([entry]) => setIntersectionEntry(entry), {
      root,
      rootMargin,
      threshold
    })

    ref?.current && observer.current.observe(ref.current)

    return () => {
      observer.current.disconnect()
    }
  }, [ref])

  return intersectionEntry
}

export default useIntersect
